import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'antd'
import shallow from 'zustand/shallow'

import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import PerButtonCircle from '../ButtonCircle'
import { useForecastModalStore } from '.'
import { ForeacastModalTabs } from './types'

const { TabPane } = Tabs

export const ForecastModalHeader: FC<unknown> = () => {
  const { t } = useTranslation()
  const [toggleActiveTab, toggleModal, activeTab] = useForecastModalStore(
    (state) => [state.toggleActiveTab, state.toggleModal, state.activeTab],
    shallow,
  )

  return (
    <PerFlexRow justify="space-between" align="middle">
      <PerFlexRow>
        <PerText fontSize="xl" color="primary">
          {t('pyramidsView.shared.infoBox.editForecast')}
        </PerText>
      </PerFlexRow>
      <Tabs
        activeKey={activeTab}
        onChange={(activeTab) => toggleActiveTab(activeTab as ForeacastModalTabs)}
        tabBarExtraContent={
          <PerFlexRow ml="xs">
            <PerButtonCircle
              size="large"
              icon="close_stroke"
              color="transparent"
              onClick={() => toggleModal(false)}
              testid="fc-modal-close"
            />
          </PerFlexRow>
        }
      >
        <TabPane tab={t('pyramidsView.forecastModal.tabs.activeEmployees')} key={ForeacastModalTabs.Employees} />
        <TabPane tab={t('pyramidsView.forecastModal.tabs.newHirings')} key={ForeacastModalTabs.Hirings} />
      </Tabs>
    </PerFlexRow>
  )
}
